export default {
    key: 'jtp',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: '0be07f23-6ecd-4770-b829-e2c5444ec6f4',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: true,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: true,
    upsells: ['upsell-joch-jtp'],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: 'JUNGFRAU_TRAVEL_PASS',
    listingId: '0be07f23-6ecd-4770-b829-e2c5444ec6f4',
    contentfulId: 'jtp',
    steps: [],
} satisfies ProductConfigActivity;
